(() => {
  if (window.blogCategoryFollowInstalled) return;
  window.blogCategoryFollowInstalled = true;
  const initialize = (root) => root.querySelectorAll('form[data-blog-follow]').forEach(form => {
    if (/^[A-Za-z0-9]{6}$/.test(form.dataset.company) && /^[A-Za-z0-9]{6}$/.test(form.dataset.list)) form.querySelector('fieldset').disabled = false;
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('form[data-blog-follow]')) return;
    event.preventDefault();
    if (form.dataset.pending || !form.reportValidity()) return;
    const status = form.querySelector('[role="status"]');
    if (form.elements.website.value) return;
    const email = form.elements.email.value.trim();
    const payload = {data:{type:'subscription',attributes:{custom_source:'Blogkategori | '+form.dataset.category,profile:{data:{type:'profile',attributes:{email,locale:'da-DK',subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:form.dataset.list}}}}};
    form.dataset.pending = 'true';
    form.querySelector('fieldset').disabled = true;
    status.textContent = 'Sender din tilmelding …';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(form.dataset.company),{method:'POST',credentials:'omit',redirect:'error',cache:'no-store',headers:{'Content-Type':'application/vnd.api+json','revision':'2026-10-15','Accept':'application/vnd.api+json'},body:JSON.stringify(payload),signal:controller.signal});
      if (response.status !== 202) {
        status.textContent = 'Tilmeldingen blev ikke accepteret. Kontrollér e-mailadressen og prøv igen senere.';
        delete form.dataset.pending;
        form.querySelector('fieldset').disabled = false;
        return;
      }
      form.reset();
      status.textContent = 'Tak! Tjek din indbakke for en eventuel bekræftelse. Du får besked om kommende indlæg, når din tilmelding er bekræftet.';
    } catch {
      // A timeout is not proof of failure. Never resubmit consent automatically.
      status.textContent = 'Vi kunne ikke bekræfte resultatet. Tjek din indbakke, før du prøver at tilmelde dig igen.';
    } finally { clearTimeout(timeout); }
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
})();
